export default __webpack_public_path__ + "static/media/francois-x.4c59418d.jpg";